import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5745 9.14674L14.7691 1.34131L12.9374 4.68447C12.1248 6.16756 10.8028 7.30635 9.21568 7.89032L4.23994 9.72116L3.04688 19.5366L11.0021 11.5814L12.4163 12.9957L4.46171 20.9502L14.2774 19.7565L16.1154 14.7209C16.6865 13.156 17.7971 11.8461 19.2475 11.0266L22.5745 9.14674Z"}}]};

const PenFilled = Vue.extend<IconProps>({
  name: 'PenFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'pen-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PenFilled;
